export const ANIMALS = [
  { emoji: '🐶', name: 'Dog' },
  { emoji: '🐱', name: 'Cat' },
  { emoji: '🐭', name: 'Mouse' },
  { emoji: '🐹', name: 'Hamster' },
  { emoji: '🐰', name: 'Rabbit' },
  { emoji: '🦊', name: 'Fox' },
  { emoji: '🐻', name: 'Bear' },
  { emoji: '🐼', name: 'Panda' },
  { emoji: '🐨', name: 'Koala' },
  { emoji: '🐯', name: 'Tiger' },
  { emoji: '🦁', name: 'Lion' },
  { emoji: '🐮', name: 'Cow' },
  { emoji: '🐷', name: 'Pig' },
  { emoji: '🐸', name: 'Frog' },
  { emoji: '🐵', name: 'Monkey' },
  { emoji: '🐧', name: 'Penguin' },
  { emoji: '🦆', name: 'Duck' },
  { emoji: '🦉', name: 'Owl' },
  { emoji: '🐺', name: 'Wolf' },
  { emoji: '🦄', name: 'Unicorn' },
  { emoji: '🐝', name: 'Bee' },
  { emoji: '🦋', name: 'Butterfly' },
  { emoji: '🐬', name: 'Dolphin' },
  { emoji: '🦀', name: 'Crab' },
  { emoji: '🦔', name: 'Hedgehog' },
];

export function getRandomAnimal(): string {
  return ANIMALS[Math.floor(Math.random() * ANIMALS.length)].emoji;
}
